import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AGSWin, AGSWinTypes } from "ags/integration/schema/ags-spin-response-schema";
import betModel from "slotworks/model/bets/bet-model";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import WaysResult from "slotworks/model/gameplay/records/results/ways-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import slotDefinition from "slotworks/model/slot-definition";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import Point from "slotworks/utils/geom/point";

export class WaysResultBuilder extends AGSResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const win = data as AGSWin;
        return win.evaluationType && win.evaluationType === AGSWinTypes.POWER_X_STREAM;
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as AGSWin;
        const symbolDef = slotDefinition.symbolDefinitions[agsWin.symbolId];
        const grid = (record as SpinRecord).grid;

        const result = new WaysResult();
        result.symbolType = symbolDef.id;
        result.perWayPayout = agsWin.multiplier;
        result.multiplier = agsWin.multiplier / betModel.getCreditSize();
        result.cashWon = agsWin.winAmount;
        result.ways = agsWin.ways;

        result.positions = agsWin.winningSymbolsPositions.map((coords: number[]) => new Point(coords[0], coords[1]));

        result.waysSymbols = [];
        result.positions.forEach((position: Point) => {
            if (!result.waysSymbols[position.x]) {
                result.waysSymbols[position.x] = [];
            }
            result.waysSymbols[position.x].push(grid[position.x][position.y]);
        });
        result.matches = result.waysSymbols.filter(Boolean).length;

        result.flattenWaysSymbols();

        const freespinResults = this.processFreespinData(record, data, result);

        return [result, ...freespinResults];
    }
}

export default new WaysResultBuilder();
